export default __webpack_public_path__ + "static/media/compensate-white-alt.be05564b.svg";